module.exports = __webpack_public_path__ + "static/media/cn_logo_verde_letra.8b09e957.svg";